<template>
  <div class="upload-base--com">
    <div class="upload-main">
      <div class="el-upload el-upload--text" @dragover="fileDragover" @drop="fileDrop">
        <div class="el-upload-dragger">
          <template v-if="!fileName">
            <label for="fileInput"><i class="el-icon-upload"></i></label>
          </template>
          <template v-else>
            <span class="file-name">{{fileName}}</span>
          </template>
          <label class="el-upload__text" for="fileInput">
            将附件拖到此处，或
            <br>
            <em>点击选择</em>
            <br>
            <!-- <span style="font-size: 12px;">excel\word\zip\pdf格式</span> -->
          </label>
        </div>
        <input
          id="fileInput"
          type="file"
          name="file"
          :accept="acceptList"
          @change="chooseUploadFile"
          class="el-upload__input">
      </div>
    </div>
    <div class="upload-action">
      <el-button type="primary" @click="upload" size="mini">{{btnName || '上传'}}</el-button>
    </div>
    <uploadProgress :percent="percent" @cancel="handleCancel"></uploadProgress>
  </div>
</template>

<script>
import api from '../../api/index'
import uploadProgress from '../components/uploadProgress'
import axios from 'axios'
export default {
  props: ['uploadMethod', 'btnName', 'acceptList', 'extaParam', 'overSizeTip'],
  data () {
    return {
      fileName: '',
      percent: 0,
      fileSize: 1000
    }
  },
  methods: {
    // 拖拽上传
    fileDragover (e) {
      e.preventDefault()
    },
    fileDrop (e) {
      e.preventDefault()
      const file = e.dataTransfer.files[0] // 获取到第一个上传的文件对象
      if (!file) return
      if (file.size > ((this.fileSize || 10) * 1000 * 1000)) {
        // this.$message({
        //   message: '文件大小不能超过' + (this.fileSize || 10) + 'M' + (this.overSizeTip || ''),
        //   type: 'warning'
        // })
        this.$toast.text('文件大小不能超过' + (this.fileSize || 10) + 'M' + (this.overSizeTip || ''))
        return
      }
      this.batchFile = file
      this.fileName = file.name
    },
    chooseUploadFile (e) {
      const file = e.target.files[0]
      if (!file) return
      if (file.size > ((this.fileSize || 10) * 1000 * 1000)) {
        // this.$message({
        //   message: '文件大小不能超过' + (this.fileSize || 10) + 'M' + (this.overSizeTip || ''),
        //   type: 'warning'
        // })
        this.$toast.text('文件大小不能超过' + (this.fileSize || 10) + 'M' + (this.overSizeTip || ''))
        return
      }
      this.batchFile = file
      this.fileName = file.name
      e.target.value = ''
    },
    upload () {
      if (!this.fileName) {
        // this.$message({
        //   message: '请选择上传文件',
        //   type: 'warning'
        // })
        this.$toast.text('请选择上传文件')
        return
      }
      this.$emit('beforeUpload')
    },
    doUpload () {
      this.CancelToken = axios.CancelToken
      this.source = this.CancelToken.source()
      // this.loading = this.$loading()
      api[this.uploadMethod](Object.assign({}, {
        multipartFile: this.batchFile
      }, this.extaParam), (percent) => {
        this.percent = percent
      }, this.source.token).then(res => {
        // this.loading && this.loading.close()
        if (res.code === 200) {
          setTimeout(() => {
            this.percent = 0
          }, 100)
          this.$emit('uploadSuccess', res.data)
        } else {
          // this.$message({
          //   message: res.message || '上传失败',
          //   type: 'warning'
          // })
          this.$toast.text(res.message || '上传失败')
        }
      })
    },
    handleCancel () {
      setTimeout(() => {
        this.percent = 0
      }, 100)
      this.$emit('cancelUpload')
      this.source.cancel('Operation canceled by the user.')
    }
  },
  components: {
    uploadProgress
  }
}
</script>

<style lang="scss">
.upload-base--com {
  .upload-main {
    display: flex;
    justify-content: space-around;
    align-items: center;
    .el-upload-right {
      flex: 0;
      .el-form-item {
        margin-bottom: 0;
      }
      .el-cascader {
        margin-bottom: 0!important;
      }
      .el-form-item__error {
        padding-top: 0;
        top: 40px;
      }
      .el-date-editor.el-input {
        width: 172px;
        margin-bottom: 12px;
      }
      .el-select, .el-cascader {
        margin-bottom: 12px;
      }
    }
    .el-upload-dragger {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 140px;
      margin: 0 auto;
      .file-name {
        width: 100%;
        font-weight: bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 4px;
      }
    }
    .el-upload-dragger {
      height: 140px;
    }
    .el-icon-upload {
      margin: 0;
    }
    label {
      display: block;
    }
  }
  .upload-action {
    margin-top: 20px;
    text-align: center;
  }
}
</style>
